// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.login-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.login-background-gradient {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f8f8f8 0%, #e8e8e8 30%, #d4d4d4 60%, #e8e8e8 100%);
}

.login-background-shimmer {
  position: absolute;
  top: 0;
  left: -100%;
  width: 200%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(201, 169, 98, 0.03) 25%,
    transparent 50%,
    rgba(201, 169, 98, 0.03) 75%,
    transparent 100%
  );
  animation: shimmer-move 8s infinite;
}

@keyframes shimmer-move {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.login-content {
  position: relative;
  z-index: 1;
  padding: 24px;
}

.login-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px);
  border-radius: 20px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12), 0 2px 10px rgba(0, 0, 0, 0.08) !important;
  padding: 40px;
  border: 1px solid rgba(201, 169, 98, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.login-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 16px;
}

.logo-diamond {
  font-size: 48px;
  background: linear-gradient(135deg, #C9A962 0%, #8B7355 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: sparkle 3s infinite;
}

@keyframes sparkle {
  0%, 100% {
    filter: drop-shadow(0 0 4px rgba(201, 169, 98, 0.5));
  }
  50% {
    filter: drop-shadow(0 0 12px rgba(201, 169, 98, 0.8));
  }
}

.logo-text {
  display: flex;
  flex-direction: column;
}

.logo-title {
  font-size: 36px !important;
  font-weight: 700 !important;
  background: linear-gradient(135deg, #2C2C2C 0%, #6B6B6B 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 !important;
}

.logo-subtitle {
  font-size: 14px;
  color: #8B7355;
  margin-top: 4px;
}

.login-tagline {
  font-size: 13px;
  color: #8A8A8A;
  letter-spacing: 2px;
}

.gold-divider {
  height: 2px;
  background: linear-gradient(90deg, transparent 0%, #C9A962 50%, transparent 100%);
  margin: 24px 0;
}

.error-alert {
  border-radius: 12px;
  border: 1px solid rgba(255, 77, 79, 0.2);
}

.login-form {
  margin-top: 8px;
}

.login-input {
  border-radius: 12px !important;
  border: 1px solid #C0C0C0 !important;
  height: 48px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.login-input:focus {
  border-color: #C9A962 !important;
  box-shadow: 0 0 0 3px rgba(201, 169, 98, 0.1) !important;
}

.input-icon {
  color: #8A8A8A;
}

.login-options {
  margin-bottom: 20px !important;
}

.remember-me-label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.remember-me-checkbox {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  accent-color: #C9A962;
}

.remember-me-text {
  font-size: 13px;
  color: #6B6B6B;
}

.forgot-password-btn {
  color: #C9A962 !important;
  padding: 0 !important;
  font-size: 13px;
}

.forgot-password-btn:hover {
  color: #8B7355 !important;
}

.login-btn {
  height: 52px;
  border-radius: 12px !important;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(145deg, #C9A962 0%, #8B7355 100%) !important;
  border: none !important;
  box-shadow: 0 4px 16px rgba(201, 169, 98, 0.4);
  transition: all 0.3s ease;
}

.login-btn:hover {
  background: linear-gradient(145deg, #E8D4A8 0%, #C9A962 100%) !important;
  box-shadow: 0 6px 20px rgba(201, 169, 98, 0.5);
  transform: translateY(-1px);
}

.login-btn:active {
  transform: translateY(0);
}

.login-footer {
  margin-top: 8px;
}

.footer-text {
  font-size: 12px;
}

.footer-contact {
  font-size: 11px;
}

.login-tips {
  margin-top: 24px;
}

.tips-alert {
  border-radius: 12px;
  background: rgba(201, 169, 98, 0.05) !important;
  border: 1px solid rgba(201, 169, 98, 0.2);
}

.tips-alert .ant-alert-message {
  color: #8B7355;
  font-weight: 500;
}

.tips-alert .ant-alert-description {
  color: #6B6B6B;
  font-size: 13px;
}

.tips-alert .ant-alert-icon {
  color: #C9A962;
}

@media (max-width: 768px) {
  .login-card {
    padding: 24px;
  }
  
  .logo-diamond {
    font-size: 36px;
  }
  
  .logo-title {
    font-size: 28px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uFAAuF;AACzF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;;;GAOC;EACD,mCAAmC;AACrC;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,gDAAgD;EAChD,2BAA2B;EAC3B,8BAA8B;EAC9B,sFAAsF;EACtF,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE;IACE,oDAAoD;EACtD;EACA;IACE,qDAAqD;EACvD;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iFAAiF;EACjF,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,wEAAwE;EACxE,uBAAuB;EACvB,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,wEAAwE;EACxE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".login-container {\r\n  position: relative;\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.login-background {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 0;\r\n}\r\n\r\n.login-background-gradient {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(135deg, #f8f8f8 0%, #e8e8e8 30%, #d4d4d4 60%, #e8e8e8 100%);\r\n}\r\n\r\n.login-background-shimmer {\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 200%;\r\n  height: 100%;\r\n  background: linear-gradient(\r\n    90deg,\r\n    transparent 0%,\r\n    rgba(201, 169, 98, 0.03) 25%,\r\n    transparent 50%,\r\n    rgba(201, 169, 98, 0.03) 75%,\r\n    transparent 100%\r\n  );\r\n  animation: shimmer-move 8s infinite;\r\n}\r\n\r\n@keyframes shimmer-move {\r\n  0% {\r\n    left: -100%;\r\n  }\r\n  100% {\r\n    left: 100%;\r\n  }\r\n}\r\n\r\n.login-content {\r\n  position: relative;\r\n  z-index: 1;\r\n  padding: 24px;\r\n}\r\n\r\n.login-card {\r\n  background: rgba(255, 255, 255, 0.95) !important;\r\n  backdrop-filter: blur(10px);\r\n  border-radius: 20px !important;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12), 0 2px 10px rgba(0, 0, 0, 0.08) !important;\r\n  padding: 40px;\r\n  border: 1px solid rgba(201, 169, 98, 0.1);\r\n}\r\n\r\n.login-header {\r\n  text-align: center;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.login-logo {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 16px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.logo-diamond {\r\n  font-size: 48px;\r\n  background: linear-gradient(135deg, #C9A962 0%, #8B7355 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  animation: sparkle 3s infinite;\r\n}\r\n\r\n@keyframes sparkle {\r\n  0%, 100% {\r\n    filter: drop-shadow(0 0 4px rgba(201, 169, 98, 0.5));\r\n  }\r\n  50% {\r\n    filter: drop-shadow(0 0 12px rgba(201, 169, 98, 0.8));\r\n  }\r\n}\r\n\r\n.logo-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.logo-title {\r\n  font-size: 36px !important;\r\n  font-weight: 700 !important;\r\n  background: linear-gradient(135deg, #2C2C2C 0%, #6B6B6B 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  margin: 0 !important;\r\n}\r\n\r\n.logo-subtitle {\r\n  font-size: 14px;\r\n  color: #8B7355;\r\n  margin-top: 4px;\r\n}\r\n\r\n.login-tagline {\r\n  font-size: 13px;\r\n  color: #8A8A8A;\r\n  letter-spacing: 2px;\r\n}\r\n\r\n.gold-divider {\r\n  height: 2px;\r\n  background: linear-gradient(90deg, transparent 0%, #C9A962 50%, transparent 100%);\r\n  margin: 24px 0;\r\n}\r\n\r\n.error-alert {\r\n  border-radius: 12px;\r\n  border: 1px solid rgba(255, 77, 79, 0.2);\r\n}\r\n\r\n.login-form {\r\n  margin-top: 8px;\r\n}\r\n\r\n.login-input {\r\n  border-radius: 12px !important;\r\n  border: 1px solid #C0C0C0 !important;\r\n  height: 48px;\r\n  font-size: 14px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.login-input:focus {\r\n  border-color: #C9A962 !important;\r\n  box-shadow: 0 0 0 3px rgba(201, 169, 98, 0.1) !important;\r\n}\r\n\r\n.input-icon {\r\n  color: #8A8A8A;\r\n}\r\n\r\n.login-options {\r\n  margin-bottom: 20px !important;\r\n}\r\n\r\n.remember-me-label {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.remember-me-checkbox {\r\n  width: 16px;\r\n  height: 16px;\r\n  margin-right: 8px;\r\n  accent-color: #C9A962;\r\n}\r\n\r\n.remember-me-text {\r\n  font-size: 13px;\r\n  color: #6B6B6B;\r\n}\r\n\r\n.forgot-password-btn {\r\n  color: #C9A962 !important;\r\n  padding: 0 !important;\r\n  font-size: 13px;\r\n}\r\n\r\n.forgot-password-btn:hover {\r\n  color: #8B7355 !important;\r\n}\r\n\r\n.login-btn {\r\n  height: 52px;\r\n  border-radius: 12px !important;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  background: linear-gradient(145deg, #C9A962 0%, #8B7355 100%) !important;\r\n  border: none !important;\r\n  box-shadow: 0 4px 16px rgba(201, 169, 98, 0.4);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.login-btn:hover {\r\n  background: linear-gradient(145deg, #E8D4A8 0%, #C9A962 100%) !important;\r\n  box-shadow: 0 6px 20px rgba(201, 169, 98, 0.5);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.login-btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.login-footer {\r\n  margin-top: 8px;\r\n}\r\n\r\n.footer-text {\r\n  font-size: 12px;\r\n}\r\n\r\n.footer-contact {\r\n  font-size: 11px;\r\n}\r\n\r\n.login-tips {\r\n  margin-top: 24px;\r\n}\r\n\r\n.tips-alert {\r\n  border-radius: 12px;\r\n  background: rgba(201, 169, 98, 0.05) !important;\r\n  border: 1px solid rgba(201, 169, 98, 0.2);\r\n}\r\n\r\n.tips-alert .ant-alert-message {\r\n  color: #8B7355;\r\n  font-weight: 500;\r\n}\r\n\r\n.tips-alert .ant-alert-description {\r\n  color: #6B6B6B;\r\n  font-size: 13px;\r\n}\r\n\r\n.tips-alert .ant-alert-icon {\r\n  color: #C9A962;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .login-card {\r\n    padding: 24px;\r\n  }\r\n  \r\n  .logo-diamond {\r\n    font-size: 36px;\r\n  }\r\n  \r\n  .logo-title {\r\n    font-size: 28px !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
